import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({ providedIn: 'root' })
export class ApiDataTravelMemberDietService {
  constructor(private _api: ApiService) {}

  get(id: number | string) {
    return this._api.get('data-travel-member-diet/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('data-travel-member-diet/list', data);
  }

  create(data: any) {
    return this._api.post('data-travel-member-diet/create', data);
  }

  update(data: any) {
    return this._api.post('data-travel-member-diet/update', data);
  }

  remove(id: number) {
    return this._api.post('data-travel-member-diet/remove/id/' + id);
  }
}
